export const UNSUPPORTED_FORMAT = (format: string): string => `Unsupported serialization format: ${format}`

export const DPACK_NOT_SUPPORTED_ON_DENO = () => 'Dpack serialization is not supported on Deno'
